import { useEffect, useRef, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import _ from "lodash";
import api_requests from "../../resources/api_requests";
import { useNavigate } from "react-router-dom";
import {
  AddCircle,
  ArrowRightFilledCircle,
  CrossCircleFilled,
} from "../../assets/whiteLabelIcon";
import ConfirmClose from "../../modules/modals/ConfirmClose";
import Footer from "../../Footer";
import AddressItem from "./AddressItem";
import AddressItemContentLoader from "./AddressItemContentLoader";
import { ArrowRightIcon } from "@radix-ui/react-icons";
import { useTranslation } from "react-i18next";

// const tab_list = [
//   { title: "Saved Pickup Address", value: "PICKUP" },
//   { title: "Saved Delivery Address", value: "DROP" },
// ];

const SavedAddresses = () => {
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [addresses, set_addresses] = useState([]);
  const [input_val, set_input_val] = useState("");
  const [refresh, set_refresh] = useState(false);
  const [delete_confirm, set_delete_confirm] = useState({
    open: false,
    id: "",
  });
  const [loaderCount, setLoaderCount] = useState(3);

  useEffect(() => {
    const updateCount = () => {
      const ITEM_HEIGHT = 80;
      setLoaderCount(Math.ceil(window.innerHeight / ITEM_HEIGHT));
    };

    updateCount();
    window.addEventListener("resize", updateCount);

    return () => window.removeEventListener("resize", updateCount);
  }, []);

  const original_address_ref = useRef([]);
  // const [selected_tab, set_selected_tab] = useState("PICKUP");

  useEffect(() => {
    get_addresses();
  }, []);

  useEffect(() => {
    if (refresh) {
      get_addresses();
      set_refresh(false);
    }
  }, [refresh]);

  const handle_input_change = (e) => {
    const val = e.target.value;
    set_input_val(val);

    const searchTerm = val.trim().toLowerCase();

    if (!searchTerm) {
      set_addresses(original_address_ref.current);
      return;
    }

    const filtered = original_address_ref.current.filter((item) => {
      const addressMatch =
        item.address_line1?.toLowerCase().includes(searchTerm) ||
        item?.label?.toLowerCase().includes(searchTerm);

      const pocMatch =
        Array.isArray(item.poc) &&
        item.poc.some(
          (poc) => poc.mobile && poc.mobile.toString().includes(searchTerm),
        );

      return addressMatch || pocMatch;
    });

    set_addresses(filtered);
  };

  const get_addresses = async () => {
    setLoading(true);
    try {
      const response = await api_requests.get_saved_address({
        recent_count: 0,
        saved_count: 20,
        master_zone_id: 0,
      });
      original_address_ref.current = response.data.saved;
      set_addresses(original_address_ref.current);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handle_clear_filter = () => {
    set_input_val("");
    set_addresses(original_address_ref.current);
  };

  const handle_back_press = () => {
    navigate(-1);
  };

  const handle_delete_confirm = async () => {
    try {
      set_delete_confirm({ open: false, id: "" });
      setLoading(true);
      await api_requests.delete_address(delete_confirm.id);
      set_refresh(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // const handle_tab_switch = (tab = selected_tab) => {
  //   const lowerSearchTerm = tab.toLowerCase();
  //   const tabs = [lowerSearchTerm];
  //   if (lowerSearchTerm === "pickup") {
  //     tabs.push(undefined);
  //     tabs.push("");
  //   }
  //   const filtered = _.filter(original_address_ref.current, (item) =>
  //     _.includes(tabs, item?.meta_info?.type)
  //   );

  //   set_addresses(filtered);
  // };

  const { t } = useTranslation();

  return (
    <div className="min-h-screen px-6 py-5 overflow-hidden h-[100vh]">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-1.5" onClick={handle_back_press}>
          <img
            src={ImageLinks.chevron_right}
            className="w-[18px] h-[19px]"
            alt="icon"
          />
          <p className="font-custom text-sm font-semibold text-dark_black">
            {t("saved_addresses")}
          </p>
        </div>
        {!_.isEmpty(addresses) && (
          <div
            className="flex items-center"
            onClick={() => navigate("/search-location?type=new")}
          >
            <AddCircle />
            <p className="ml-1 font-custom font-semibold text-xs text-primary">
              {t("save_address")}
            </p>
          </div>
        )}
      </div>

      <section className="mb-4">
        <div
          className={`flex items-center border border-accents rounded-[30px]  px-4 py-2 bg-white mt-4`}
        >
          <input
            id="pac-input"
            type="text"
            placeholder={t('search_by_label')}
            className={`w-full text-gray-700 placeholder-gray-500 bg-transparent text-sm focus:outline-none`}
            onChange={handle_input_change}
            value={input_val}
          />
          <div style={{ opacity: _.isEmpty(input_val) ? 0.3 : 1 }}>
            {!_.isEmpty(input_val) ? (
              <div onClick={handle_clear_filter}>
                <CrossCircleFilled />
              </div>
            ) : (
              <div onClick={handle_clear_filter}>
                <ArrowRightFilledCircle />
              </div>
            )}
          </div>
        </div>
      </section>

      {/* <section className="mb-4 flex gap-8">
        {_.map(tab_list, (tab_item, tab_index) => (
          <div
            key={`tab_item${tab_index}`}
            className={`${
              tab_item?.value === selected_tab ? "border-b-2" : "border-b-0"
            } border-secondary pb-2 px-4`}
            onClick={() => {
              handle_tab_switch(tab_item?.value);
              set_selected_tab(tab_item?.value);
              set_input_val("");
            }}
          >
            <p
              className={`font-custom font-semibold ${
                tab_item.value === selected_tab
                  ? "text-secondary"
                  : "text-accents"
              } text-xs`}
            >
              {tab_item.title}
            </p>
          </div>
        ))}
      </section> */}
      {!isLoading && _.isEmpty(addresses) ? (
        <div className="flex flex-col justify-center w-full p-10 items-center h-[65vh] gap-2">
          <p className="font-custom text-xs font-medium text-dark_gray">
            {t("dont_have_address")}
          </p>
          <div
            className="flex items-center"
            onClick={() => navigate("/search-location?type=new")}
          >
            <AddCircle />
            <p className="ml-1 font-custom font-semibold text-xs text-secondary">
              {t("save_new_address")}
            </p>
          </div>
        </div>
      ) : (
        <div
          className="flex flex-col gap-6 overflow-auto p-2"
          style={{
            height: `calc(100vh - 228px - env(safe-area-inset-bottom))`,
          }}
        >
          {isLoading ? (
            <div className="overflow-hidden flex flex-col gap-6 p-2">
              {Array.from({ length: loaderCount }).map((_, i) => (
                <AddressItemContentLoader key={i} />
              ))}
            </div>
          ) : (
            _.map(addresses, (item) => {
              return (
                <AddressItem
                  key={`address_item_${item.id}`}
                  item={item}
                  set_delete_confirm={set_delete_confirm}
                />
              );
            })
          )}
        </div>
      )}
      <Footer bottom={0} />
      {delete_confirm.open && (
        <ConfirmClose
          main_title="Are you sure, you want to delete the saved address?"
          cancel_button_text="Cancel"
          action_button_text="Delete"
          cancel_button={() => set_delete_confirm({ open: false, id: "" })}
          action_button={handle_delete_confirm}
        />
      )}
    </div>
  );
};

export default SavedAddresses;
